/**
 * @typedef {Object} SupplierRating
 * @property {string}      id           - unique identifier (rtg-NNN)
 * @property {string}      supplierName - matches suppliers[].name
 * @property {string|null} quoteId      - optional FK to supplierQuotes[].id or quoteHistory[].id
 * @property {string|null} ticketNumber - optional display context (e.g. 'INC10041')
 * @property {number}      rating       - integer 1–5
 * @property {string}      review       - free-text review from coordinator
 * @property {string}      ratedBy      - name of internal user who submitted
 * @property {string}      ratedAt      - ISO date string
 */

/** @type {SupplierRating[]} */
export const supplierRatings = [
  {
    id: 'rtg-001',
    supplierName: 'Vantage Technology Supply',
    quoteId: 'sqh-001',
    ticketNumber: 'INC10063',
    rating: 5,
    review: 'Highly responsive — quote received within hours. Competitive pricing and shipped ahead of the committed schedule.',
    ratedBy: 'Adam Harrison',
    ratedAt: '2026-03-22',
  },
  {
    id: 'rtg-002',
    supplierName: 'Vantage Technology Supply',
    quoteId: null,
    ticketNumber: 'INC10041',
    rating: 4,
    review: 'Good pricing and reliable turnaround. Minor delay in confirmation email but delivery was on time.',
    ratedBy: 'Claire Dupont',
    ratedAt: '2026-01-16',
  },
  {
    id: 'rtg-003',
    supplierName: 'Crestline Distribution',
    quoteId: 'sqh-004',
    ticketNumber: 'INC10088',
    rating: 3,
    review: 'Pricing was within acceptable range but response time was slower than expected given the SLA window.',
    ratedBy: 'Adam Harrison',
    ratedAt: '2026-03-23',
  },
  {
    id: 'rtg-004',
    supplierName: 'Crestline Distribution',
    quoteId: null,
    ticketNumber: 'INC10011',
    rating: 4,
    review: 'Solid stock availability and good communication throughout the order. Would use again for memory SKUs.',
    ratedBy: 'Claire Dupont',
    ratedAt: '2025-09-10',
  },
  {
    id: 'rtg-005',
    supplierName: 'Bridgepoint Components',
    quoteId: 'sqh-007',
    ticketNumber: 'INC10125',
    rating: 5,
    review: 'Best price across all respondents and fastest response time. Same-day shipping confirmed at time of order.',
    ratedBy: 'Adam Harrison',
    ratedAt: '2026-03-28',
  },
  {
    id: 'rtg-006',
    supplierName: 'Bridgepoint Components',
    quoteId: null,
    ticketNumber: 'INC10048',
    rating: 4,
    review: 'Consistently competitive on networking SKUs. Recommend as preferred vendor for NIC and SFP parts.',
    ratedBy: 'Claire Dupont',
    ratedAt: '2026-02-01',
  },
  {
    id: 'rtg-007',
    supplierName: 'Pinnacle Technology Group',
    quoteId: 'sqh-005',
    ticketNumber: 'INC10188',
    rating: 3,
    review: 'Adequate response and competitive enough pricing, but lead time was longer than optimal for this SLA.',
    ratedBy: 'Adam Harrison',
    ratedAt: '2026-04-04',
  },
  {
    id: 'rtg-008',
    supplierName: 'Pinnacle Technology Group',
    quoteId: null,
    ticketNumber: 'INC10044',
    rating: 4,
    review: 'Delivered on time with an accurate invoice. Good option for DC power supply parts.',
    ratedBy: 'Marcus Webb',
    ratedAt: '2025-12-13',
  },
  {
    id: 'rtg-009',
    supplierName: 'Nexus Tech Partners',
    quoteId: null,
    ticketNumber: 'INC10072',
    rating: 3,
    review: 'First order with this vendor. Quote came back on time but pricing was above market average. Will evaluate further before committing larger volume.',
    ratedBy: 'Adam Harrison',
    ratedAt: '2026-02-18',
  },
];
